/* =========================================================
   UNITED STORE — PRODUCT.JS
   - Galería swipe + dots + thumbnails
   - Selector de variantes (talla 3 opciones: COL/EUR/USA)
   - Tabs de sistema de tallas
   - Add to cart AJAX con feedback
   ========================================================= */
(function () {
  'use strict';
 
  /* ============ DATOS DE VARIANTES ============ */
  const variantsScript = document.getElementById('product-variants-json');
  if (!variantsScript) return;
 
  let variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent || '[]');
  } catch (e) {
    console.error('Variants JSON parse error', e);
    return;
  }
 
  /* ============ ESTADO ============ */
  const selectedOptions = {};
  const variantIdInput = document.getElementById('variant-id');
  const addBtn = document.getElementById('add-to-cart-btn');
  /* Cambiar type a button para evitar submit nativo duplicado */
  if (addBtn) addBtn.type = 'button';
  const btnLabel = addBtn ? addBtn.querySelector('[data-btn-label]') : null;
  const priceEl = document.getElementById('product-price');
  const msgEl = document.getElementById('add-to-cart-message');

  /* ---- Stock indicator (se inyecta dinámicamente) ---- */
  function getOrCreateStockEl() {
    let el = document.getElementById('us-stock-indicator');
    if (!el) {
      el = document.createElement('p');
      el.id = 'us-stock-indicator';
      el.className = 'font-label-caps text-label-caps uppercase mt-2 min-h-[1.2em]';
      /* Insertar después del botón de añadir o después del mensaje */
      const ref = document.getElementById('add-to-cart-message');
      if (ref && ref.parentNode) ref.parentNode.insertBefore(el, ref.nextSibling);
    }
    return el;
  }

  function showStockStatus(variant) {
    const el = getOrCreateStockEl();
    if (!el) return;
    if (!variant) { el.textContent = ''; return; }

    const qty = variant.inventory_quantity;
    const policy = variant.inventory_policy;   /* 'deny' | 'continue' */
    const mgmt  = variant.inventory_management; /* 'shopify' | null */

    if (!variant.available) {
      el.textContent = '✕ Agotado en esta talla';
      el.style.color = '#ef4444';
      return;
    }

    /* Mostrar cantidad si viene del endpoint /variants/{id}.js */
    if (qty !== null && qty !== undefined && mgmt === 'shopify') {
      if (qty <= 0) {
        el.textContent = '✕ Agotado en esta talla';
        el.style.color = '#ef4444';
      } else if (qty <= 3) {
        el.textContent = '⚠ Últimas ' + qty + ' unidad' + (qty === 1 ? '' : 'es') + ' disponible' + (qty === 1 ? '' : 's');
        el.style.color = '#f97316';
      } else if (qty <= 15) {
        el.textContent = '● ' + qty + ' unidades disponibles';
        el.style.color = '#22c55e';
      } else {
        el.textContent = '● En stock';
        el.style.color = '#22c55e';
      }
    } else {
      /* Sin gestión de inventario Shopify: solo disponible/agotado */
      el.textContent = variant.available ? '● En stock' : '✕ Agotado en esta talla';
      el.style.color = variant.available ? '#22c55e' : '#ef4444';
    }
  }
 
  /* ============ GALERÍA ============ */
  const track = document.getElementById('gallery-track');
  const dots = document.querySelectorAll('[data-gallery-dot]');
  const thumbs = document.querySelectorAll('[data-gallery-thumb]');
  let currentSlide = 0;
 
  function goToSlide(idx) {
    if (!track) return;
    const total = track.children.length;
    if (idx < 0) idx = 0;
    if (idx >= total) idx = total - 1;
    currentSlide = idx;
    track.style.transform = `translateX(-${idx * 100}%)`;
    dots.forEach((d, i) => d.classList.toggle('opacity-30', i !== idx));
    thumbs.forEach((t, i) => {
      t.classList.toggle('border-primary', i === idx);
      t.classList.toggle('border-transparent', i !== idx);
    });
  }
 
  dots.forEach((dot) => {
    dot.addEventListener('click', () => goToSlide(parseInt(dot.dataset.galleryDot, 10)));
  });
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => goToSlide(parseInt(thumb.dataset.galleryThumb, 10)));
  });
 
  if (track) {
    let startX = 0;
    let isDragging = false;
    track.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      const endX = e.changedTouches[0].clientX;
      const delta = endX - startX;
      if (Math.abs(delta) > 50) goToSlide(currentSlide + (delta < 0 ? 1 : -1));
      isDragging = false;
    });
  }
 
  /* ============ TABS DE SISTEMA DE TALLAS ============ */
  const sizeTabs = document.querySelectorAll('[data-size-tab]');
  const sizePanels = document.querySelectorAll('[data-size-panel]');
 
  // Mapa de equivalencias por índice entre los 3 sistemas
  // Se construye dinámicamente desde los botones
  function buildSizeMap() {
    const map = {}; // index → { col, eur, usa }
    ['col','eur','usa'].forEach(system => {
      const panel = document.querySelector(`[data-size-panel="${system}"]`);
      if (!panel) return;
      panel.querySelectorAll('[data-size-index]').forEach(btn => {
        const idx = btn.dataset.sizeIndex;
        if (!map[idx]) map[idx] = {};
        map[idx][system] = btn.dataset.variantValue;
      });
    });
    return map;
  }
 
  const sizeMap = buildSizeMap();
  let activeSystem = 'col'; // sistema activo por defecto
 
  sizeTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const system = tab.dataset.sizeTab;
      activeSystem = system;
 
      // Actualizar estilos tabs
      sizeTabs.forEach(t => {
        const isActive = t.dataset.sizeTab === system;
        t.classList.toggle('bg-primary', isActive);
        t.classList.toggle('text-on-primary', isActive);
        t.classList.toggle('text-primary', !isActive);
      });
 
      // Mostrar/ocultar panels
      sizePanels.forEach(p => {
        p.classList.toggle('hidden', p.dataset.sizePanel !== system);
      });
 
      // Si hay un índice seleccionado, seleccionar el equivalente en el nuevo sistema
      if (selectedSizeIndex !== null) {
        const panel = document.querySelector(`[data-size-panel="${system}"]`);
        if (panel) {
          const equivalentBtn = panel.querySelector(`[data-size-index="${selectedSizeIndex}"]`);
          if (equivalentBtn && !equivalentBtn.disabled) {
            selectSizeBtn(equivalentBtn, system);
          }
        }
      }
    });
  });
 
  /* ============ SELECTOR DE VARIANTES ============ */
  let selectedSizeIndex = null;
 
  function selectSizeBtn(btn, system) {
    const optName = btn.dataset.variantOption;
    const optValue = btn.dataset.variantValue;
    const idx = btn.dataset.sizeIndex;
 
    selectedSizeIndex = idx;
 
    // Desmarcar todos en este panel
    const panel = btn.closest('[data-size-panel]');
    if (panel) {
      panel.querySelectorAll('[data-variant-option]').forEach(b => b.setAttribute('aria-pressed', 'false'));
    }
    btn.setAttribute('aria-pressed', 'true');
 
    // Actualizar selectedOptions con los 3 sistemas para este índice
    if (sizeMap[idx]) {
      if (sizeMap[idx].col) selectedOptions['Talla COL'] = sizeMap[idx].col;
      if (sizeMap[idx].eur) selectedOptions['Talla EUR'] = sizeMap[idx].eur;
      if (sizeMap[idx].usa) selectedOptions['Talla USA'] = sizeMap[idx].usa;
    } else {
      selectedOptions[optName] = optValue;
    }
 
    // Mostrar conversión completa
    const detail = document.querySelector('[data-size-detail]');
    if (detail && sizeMap[idx]) {
      const parts = [];
      if (sizeMap[idx].col) parts.push(`COL ${sizeMap[idx].col}`);
      if (sizeMap[idx].eur) parts.push(`EUR ${sizeMap[idx].eur}`);
      if (sizeMap[idx].usa) parts.push(`USA ${sizeMap[idx].usa}`);
      detail.textContent = parts.join(' · ');
    }
 
    updateSelectedVariant();
  }
 
  // Botones con data-size-index (nuevo formato 3 opciones)
  document.querySelectorAll('[data-size-index]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.hasAttribute('disabled')) return;
      const system = btn.closest('[data-size-panel]')?.dataset.sizePanel || 'col';
      selectSizeBtn(btn, system);
    });
  });
 
  // Botones legacy (sin data-size-index)
  document.querySelectorAll('[data-variant-option]:not([data-size-index])').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.hasAttribute('disabled')) return;
      const optName = btn.dataset.variantOption;
      const optValue = btn.dataset.variantValue;
 
      document.querySelectorAll(`[data-variant-option="${optName}"]`).forEach(b => {
        b.setAttribute('aria-pressed', 'false');
      });
      btn.setAttribute('aria-pressed', 'true');
      selectedOptions[optName] = optValue;
      updateSelectedVariant();
    });
  });
 
  function updateSelectedVariant() {
    const optionNames = window.productOptionNames || [];
 
    const matched = variants.find(v => {
      return v.options.every((optVal, idx) => {
        const optName = optionNames[idx];
        if (!optName) return true;
        if (!selectedOptions[optName]) return true;
        return selectedOptions[optName] === optVal;
      });
    });
 
    if (matched) {
      if (variantIdInput) variantIdInput.value = matched.id;
      if (priceEl) priceEl.textContent = formatMoney(matched.price);
      if (addBtn) {
        addBtn.disabled = !matched.available;
        if (btnLabel) btnLabel.textContent = matched.available ? 'Añadir al Carrito' : 'Agotado';
      }
      /* Fetch cantidad real de inventario */
      fetch('/variants/' + matched.id + '.js')
        .then(r => r.json())
        .then(v => showStockStatus(v))
        .catch(() => showStockStatus(matched));
    } else {
      showStockStatus(null);
    }
  }
 
  function formatMoney(cents) {
    const amount = cents / 100;
    return '$' + amount.toLocaleString('es-CO', { maximumFractionDigits: 0 });
  }
 
  /* ============ AJAX ADD TO CART ============ */
  let _submitting = false;
  const productForm = document.getElementById('product-form');
  async function handleAddToCart() {
      if (_submitting) return;

      /* Validar talla */
      const variantBtns = document.querySelectorAll('[data-variant-option]');
      if (variantBtns.length > 0) {
        const anySelected = document.querySelector('[data-variant-option][aria-pressed="true"]');
        if (!anySelected) {
          const stockEl = getOrCreateStockEl();
          if (stockEl) { stockEl.textContent = '⚠ Por favor selecciona una talla'; stockEl.style.color = '#f97316'; }
          return;
        }
      }

      _submitting = true;
      const formData = new FormData(productForm);

      if (addBtn) {
        addBtn.disabled = true;
        if (btnLabel) btnLabel.textContent = 'Añadiendo...';
      }
 
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });
 
        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.description || 'Error al añadir al carrito');
        }
 
        /* Abrir cart drawer con contenido actualizado */
        if (window.UnitedStore && window.UnitedStore.openCartDrawer) {
          window.UnitedStore.openCartDrawer();
        } else {
          /* Fallback: mostrar mensaje si no hay drawer */
          if (msgEl) {
            msgEl.classList.remove('hidden');
            setTimeout(() => msgEl.classList.add('hidden'), 3000);
          }
        }
        if (btnLabel) btnLabel.textContent = 'Añadir al Carrito';

        /* Mostrar stock restante post-add consultando /variants/{id}.js */
        const vId = variantIdInput ? variantIdInput.value : null;
        if (vId) {
          fetch('/variants/' + vId + '.js')
            .then(r => r.json())
            .then(v => showStockStatus(v))
            .catch(() => {});
        }
 
        if (window.UnitedStore && window.UnitedStore.refreshCartCount) {
          window.UnitedStore.refreshCartCount();
        }
      } catch (err) {
        if (btnLabel) btnLabel.textContent = err.message || 'Error, intenta de nuevo';
        setTimeout(() => {
          if (btnLabel) btnLabel.textContent = 'Añadir al Carrito';
        }, 2500);
      } finally {
        if (addBtn) addBtn.disabled = false;
        _submitting = false;
      }
  }

  /* Btn click → handleAddToCart (type=button, no submit nativo) */
  if (addBtn && productForm) {
    addBtn.addEventListener('click', handleAddToCart);
  }
  /* Fallback: form submit (por si hay otro trigger) */
  if (productForm) {
    productForm.addEventListener('submit', (e) => { e.preventDefault(); handleAddToCart(); });
  }
 
  /* ---- Stock inicial: fetch /variants/{id}.js para cantidad real ---- */
  (function initStock() {
    const defVariantInput = document.getElementById('variant-id');
    if (!defVariantInput) return;
    const defId = parseInt(defVariantInput.value);
    if (!defId) return;
    fetch('/variants/' + defId + '.js')
      .then(r => r.json())
      .then(v => showStockStatus(v))
      .catch(() => {
        /* Fallback al JSON del producto */
        const defVariant = variants.find(v => v.id === defId);
        if (defVariant) showStockStatus(defVariant);
      });
  })();

  /* Al cambiar variante: fetch stock real */
  const _origUpdateVariant = updateVariant;

})();